import { render } from "./SuspendedCustomers.html?vue&type=template&id=1c86c68e&scoped=true"
import script from "./SuspendedCustomers.js?vue&type=script&lang=js"
export * from "./SuspendedCustomers.js?vue&type=script&lang=js"

import "./SuspendedCustomers.css?vue&type=style&index=0&id=1c86c68e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c86c68e"]])

export default __exports__